import { render, staticRenderFns } from "./Sv2Editor.vue?vue&type=template&id=08ef582c&scoped=true&"
import script from "./Sv2Editor.vue?vue&type=script&lang=js&"
export * from "./Sv2Editor.vue?vue&type=script&lang=js&"
import style0 from "./Sv2Editor.vue?vue&type=style&index=0&id=08ef582c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef582c",
  null
  
)

export default component.exports